export const INITIAL_STAGE = 'Identify';

export const DISQUALIFIED_STAGE = 'Disqualified';

export const GET_STAGES = 'GET_STAGES/STAGES/@WISELY/WEB';
export const FETCH_STAGES_FAILED = 'FETCH_STAGES_FAILED/STAGES/@WISELY/WEB';
export const FETCH_STAGES_SUCCEEDED = 'FETCH_STAGES_SUCCEEDED/STAGES/@WISELY/WEB';



// WEBPACK FOOTER //
// ./src/redux/stages/stages.constant.js